import React from "react";

function SoundIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
    >
      <path
        id="Path_18485"
        data-name="Path 18485"
        d="M20,3V17a4,4,0,1,1-2-3.465V5H9V17a4,4,0,1,1-2-3.465V3ZM5,19a2,2,0,1,0-2-2A2,2,0,0,0,5,19Zm11,0a2,2,0,1,0-2-2A2,2,0,0,0,16,19Z"
        transform="translate(-1 -3)"
        fill="#03f"
      />
    </svg>
  );
}

export default SoundIcon;
